import ContactMsgModal from './ContactMsgModal';

export default ContactMsgModal;
